module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1009-56ca5813ff6d8a02b9896d10aee51c6d.png";